import { css } from "@vitality-ds/system";
export default css({
  width: "100%"
});